var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFull = function SvgDownloadFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 17 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.808 19.75q-.748 0-1.278-.53A1.74 1.74 0 0 1 0 17.942V8.558Q0 7.81.53 7.28t1.278-.53h3.557v1.5H1.808a.3.3 0 0 0-.222.086.3.3 0 0 0-.086.222v9.384a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h13.385a.3.3 0 0 0 .222-.087.3.3 0 0 0 .086-.22V8.557a.3.3 0 0 0-.086-.222.3.3 0 0 0-.222-.086h-3.557v-1.5h3.557q.749 0 1.278.53.53.53.53 1.278v9.384q0 .749-.53 1.278-.53.53-1.278.53zM8.5 14.904 4.846 11.25 5.9 10.196l1.85 1.835V0h1.5v12.03l1.85-1.834 1.054 1.054z"
  })));
};
export default SvgDownloadFull;